import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {Skeleton} from '../../Skeleton/Skeleton';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import {classes as crossSellClasses} from '../CrossSell.st.css';
import {classes, st} from './CrossSellCardSkeleton.st.css';

export enum CrossSellCardSkeletonDataHook {
  root = 'CrossSellCardSkeleton.root',
}

export const SKELETON_CARD_COUNT = 4;

export const crossSellSkeletonItems = (imageSize: number) =>
  Array.from({length: SKELETON_CARD_COUNT}, (_, index) => ({
    id: `skeleton-${index}`,
    content: <CrossSellCardSkeleton imageSize={imageSize} />,
  }));

const CrossSellCardSkeleton = ({imageSize}: {imageSize: number}) => (
  <Skeleton dataHook={CrossSellCardSkeletonDataHook.root} className={crossSellClasses.card}>
    <div className={crossSellClasses.imageContainer} style={{width: imageSize, height: imageSize}}>
      <SkeletonLineWrapper className={classes.image} />
    </div>
    <Text className={crossSellClasses.displayName}>
      <SkeletonLineWrapper className={st(classes.line, classes.displayNameLine)} />
    </Text>
    <Text className={crossSellClasses.price}>
      <SkeletonLineWrapper className={st(classes.line, classes.priceLine)} />
    </Text>
    <Text className={crossSellClasses.description}>
      <SkeletonLineWrapper className={st(classes.line, classes.descriptionLine)} />
    </Text>
  </Skeleton>
);
